import { render, staticRenderFns } from "./GlyphAutosortButtonGroup.vue?vue&type=template&id=38392132&scoped=true&"
import script from "./GlyphAutosortButtonGroup.vue?vue&type=script&lang=js&"
export * from "./GlyphAutosortButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38392132",
  null
  
)

export default component.exports